module.exports = __webpack_public_path__ + "img/timeoff-empty-image.624cdc80.png";